import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ zone, nextZone }) =>
    present(
      repository
        .editZone(zone, nextZone)
        .catch((error) => Promise.reject({ error, zone, nextZone })),
    );
}

export type { Interactor };

export { createInteractor };
